// extracted by mini-css-extract-plugin
module.exports = {"Card":"InfoCard_Card__23h69","CardTitle":"InfoCard_CardTitle__3NDI5","SubTitle":"InfoCard_SubTitle__vMMYF","LinkedinIcon":"InfoCard_LinkedinIcon__3f3j2"};